import { Action, createReducer, on } from '@ngrx/store';
import * as MonitoringActions from './monitoring.actions';
import { MonitoringEntity } from './monitoring.models';
import { StatusApiMsgModel } from '@kanzi-apes/kanzi-models';

enum KanziStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const MONITORING_FEATURE_KEY = 'monitoring';

export interface MonitoringState extends EntityState<MonitoringEntity> {
  status: {
    actual: KanziStatus.ONLINE | KanziStatus.OFFLINE | null;
    previous: KanziStatus.ONLINE | KanziStatus.OFFLINE | null;
  };
  statusMsg: StatusApiMsgModel | null;
}

export interface MonitoringPartialState {
  readonly [MONITORING_FEATURE_KEY]: MonitoringState;
}

export const monitoringAdapter: EntityAdapter<MonitoringEntity> =
  createEntityAdapter<MonitoringEntity>();

export const initialMonitoringState: MonitoringState =
  monitoringAdapter.getInitialState({
    status: { actual: KanziStatus.ONLINE, previous: null },
    statusMsg: null,
  });

const reducer = createReducer(
  initialMonitoringState,
  on(MonitoringActions.statusOnline, (state, { payload }) => ({
    ...state,
    status: {
      actual: KanziStatus.ONLINE,
      previous: state.status?.actual
        ? state.status?.actual
        : KanziStatus.OFFLINE,
    },
    statusMsg: payload,
  })),
  on(MonitoringActions.statusOffline, (state, { payload }) => ({
    ...state,
    status: {
      actual: KanziStatus.OFFLINE,
      previous: state.status?.actual
        ? state.status?.actual
        : KanziStatus.ONLINE,
    },
    statusMsg: payload,
  }))
);

/**
 * Monitoring reducer function for the store.
 * @param state - The current monitoring state
 * @param action - The dispatched action
 * @returns The new monitoring state
 */
export function monitoringReducer(
  state: MonitoringState | undefined,
  action: Action
) {
  return reducer(state, action);
}
